import React from "react";
import { INTAKE } from "../../constants/testIds";

const STEPS = ["Urgency", "Details", "Funding", "Help", "Questions"];

export const ProgressStepper = ({ current }) => {
  const pct = Math.min(100, Math.round(((current + 1) / STEPS.length) * 100));
  return (
    <div className="w-full" data-testid={INTAKE.progress}>
      <div className="flex items-center justify-between mb-2">
        {STEPS.map((s, i) => {
          const cls =
            i === current
              ? "text-brand-gold font-bold underline underline-offset-4 decoration-2"
              : i < current
              ? "text-brand-gold/80 font-semibold"
              : "text-muted-foreground";
          return (
            <span
              key={s}
              aria-current={i === current ? "step" : undefined}
              className={`text-[11px] uppercase tracking-widest transition-colors duration-300 ${cls}`}
            >
              {s}
            </span>
          );
        })}
      </div>
      <div className="h-[3px] w-full bg-secondary">
        <div
          className="h-full bg-brand-gold transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};
